import { initiateVue } from '../javascripts/helpers/vue-helper'
import VSelect from '../javascripts/vue-components/select/VSelect'

initiateVue({VSelect})